import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    LikeAndInfoSection,
    LikeButton,
    HeartFilledIconWrapper,
    HeartOutlinedIconWrapper,
    InfoIconWrapper,
} from './GameLikeAndInfo.style';

interface PropsType {
    isFavourite: boolean;
    gameId: number;
    onHeartClick: () => void;
    onInfoClick?: () => void;
}

export const LikeAndInfo = observer('LikeAndInfo', (props: PropsType): JSX.Element => {
    const { isFavourite, onInfoClick, onHeartClick } = props;

    return (
        <LikeAndInfoSection data-test='like-and-info-section'>
            <InfoIconWrapper onClick={onInfoClick} />

            <LikeButton
                onClick={onHeartClick}
                data-test='like-button'
            >
                {isFavourite ? <HeartFilledIconWrapper /> : <HeartOutlinedIconWrapper />}
            </LikeButton>
        </LikeAndInfoSection>
    );
});
